import React, { useState } from 'react';
import { Box, Icon, Link, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import ApplyForCreditModal from '../ApplyForCreditModal';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './CreditAndSignupCtas.styles';
import useBapCtaGtm from '../../core/gtm/hooks/useBapCtaClickGtm';
import useMyGarageToast from './useMyGarageToast';
import useSaveBuild, { useSaveBuildUnsavedChanges } from '../../core/apiHooks/useSaveBuild';
import { APPLY_FOR_CREDIT_URL, SIGNUP_FOR_UPDATES_URL } from '../../utils/constants';
import { PaymentMethod, selectPrimaryCalculatorPaymentMethod } from '../../core/reducers/financialCalculators';
import { useAppSelector } from '../../core/utils';
import { useSharedApps } from '../../utils/sitecoreContext';
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const CTA = themeStyles.apply(Link, 'CTA');
const IconWrapper = themeStyles.apply(Box, 'IconWrapper');
const CreditAndSignupCtas = ({ rendering }) => {
    const { t } = useTranslation();
    const { fireGtmEvent, currentVehicle } = useBapCtaGtm();
    const [showModal, setShowModal] = useState(false);
    const paymentMethod = useAppSelector(selectPrimaryCalculatorPaymentMethod);
    const isPaymentMethodCash = paymentMethod === PaymentMethod.cash;
    const componentName = rendering === null || rendering === void 0 ? void 0 : rendering.componentName;
    const signupForUpdatesUrl = useSharedApps(SIGNUP_FOR_UPDATES_URL);
    let applyForCreditUrl = useSharedApps(APPLY_FOR_CREDIT_URL);
    const { isProcessing, updateBuild, hasSaveBuildData, buildId } = useSaveBuild('', true);
    const { canUpdateBuild, hasUnsavedChanges, buildModelData } = useSaveBuildUnsavedChanges();
    applyForCreditUrl = `${applyForCreditUrl}/${buildId}`;
    const { triggerToast } = useMyGarageToast({ componentName });
    const isSalesTaxIncluded = buildModelData.overriddenIsSellingProvince && buildModelData.includeFees;
    function handleApplyForCreditGtm() {
        fireGtmEvent({
            ctaType: 'apply for credit',
            linkText: 'apply for credit',
            ctaPlacement: 'summary',
            componentType: componentName,
        });
    }
    function handleApplyForCreditCtaClick() {
        if (isProcessing)
            return;
        handleApplyForCreditGtm();
        if (canUpdateBuild) {
            if (isSalesTaxIncluded && !hasUnsavedChanges)
                return ApplyForCreditModal.navigateTo(applyForCreditUrl);
            return updateBuild({
                onSuccess() {
                    triggerToast(null, true);
                    ApplyForCreditModal.navigateTo(applyForCreditUrl);
                },
                onError: () => ApplyForCreditModal.navigateTo(applyForCreditUrl),
            });
        }
        setShowModal(true);
    }
    return (React.createElement(Box, null,
        React.createElement(Wrapper, null,
            React.createElement(Optional, { when: (currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelKey) && !isPaymentMethodCash && hasSaveBuildData },
                React.createElement(CTA, { styling: "primary", "data-testid": "cy-CreditCta", disabled: isProcessing, onClick: handleApplyForCreditCtaClick },
                    React.createElement(IconWrapper, { "data-testid": "cy-CreditCta_icon" },
                        React.createElement(Icon, { name: "file", iconColor: "primary" })),
                    t('Pages.Bap.applyForCreditButton'),
                    React.createElement(Icon, { name: "arrowRight", ml: "xs", iconColor: "primary" }))),
            React.createElement(CTA, { styling: "primary", "data-testid": "cy-SignupCta", as: RoutableSitecoreLink, field: { value: { href: signupForUpdatesUrl, linktype: 'external' } }, onClick: () => {
                    fireGtmEvent({
                        ctaType: 'newsletter',
                        ctaPlacement: 'summary',
                        componentType: componentName,
                        linkText: 'Sign up for updates',
                        linkUrl: signupForUpdatesUrl,
                    });
                } },
                React.createElement(IconWrapper, { "data-testid": "cy-SignupCta_icon" },
                    React.createElement(Icon, { name: "email", iconColor: "primary" })),
                t('Pages.Bap.signUpForUpdatesButton'),
                React.createElement(Icon, { name: "arrowRight", ml: "xs", iconColor: "primary" }))),
        React.createElement(ApplyForCreditModal, { closeModal: () => setShowModal(false), showModal, isSalesTaxIncluded })));
};
export default CreditAndSignupCtas;
